import { axios } from "@/main.js";
import store from "@/js/store/store";

//加载所有下拉列表
//使用 store.getters["模块名/getters方法名"]获取对应项
export async function InitAll(
  userType,
  OwnedStationCode,
  OwnedDriverSchoolCode
) {
  //平台管理员 额外加载以下
  if (userType == 0) {
    getSchoolAll(true).then(res => {
      if (res.data.Code === "10000") {
        store.dispatch("dropDown/saveSchoolList", res.data.Data);
      }
    });
  } else if (userType == 1) {
  }
  let arr = [];
  let getSchoolTeamPromise = getSchoolTeam(OwnedDriverSchoolCode).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveTeamList", res.data.Data);
    }
  });

  let getLoginNamesPromise = getLoginNames(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveLoginNameList", res.data.Data);
    }
  });

  let getRolesPromise = getRoles(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveUserRoleList", res.data.Data);
    }
  });

  let getGroupPromise = getGroup(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveGroupList", res.data.Data);
    }
  });

  let getVehicleTypePromise = getVehicleType(OwnedDriverSchoolCode, true).then(
    res => {
      if (res.data.Code === "10000") {
        store.dispatch("dropDown/saveVehicleTypeList", res.data.Data);
      }
    }
  );

  let getPersonTypePromise = getPersonType(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/savePersonTypeList", res.data.Data);
    }
  });

  let getDrivingTypePromise = getDrivingType(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveDrivingTypeList", res.data.Data);
    }
  });

  let getSubitemTypeTwoPromise = getSubitemTypeTwo().then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveSubitemTypeTwoList", res.data.Data);
    }
  });

  let getGroupTreePromise = getGroupTree(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveGroupTreeList", res.data.Data);
    }
  });
  //获取车辆品牌字典
  let getVehicleModelSettingPromise = getVehicleModelSetting().then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveVehicleModelSettingList", res.data.Data);
    }
  });
  //获取资源类型字典
  let GetResourceTypePromise = GetResourceType().then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveResourceTypeList", res.data.Data);
    }
  });
  //获取资源类型KeyPrefix列表
  let GetResourceTypeKeyPrefixPromise = GetResourceTypeKeyPrefix().then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveResourceTypeKeyPrefixList", res.data.Data);
    }
  });
  //获取文件类型字典
  let GetFileTypePromise = GetFileType().then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveFileTypeList", res.data.Data);
    }
  });
  //获取车辆品牌下拉列表
  let getVehicleModelSettingDropListPromise = getVehicleModelSettingDropList().then(
    res => {
      if (res.data.Code === "10000") {
        store.dispatch("dropDown/saveVehicleModelDropdownList", res.data.Data);
      }
    }
  );
  //获取车辆品牌与车牌号下拉列表
  let getVehicleModelAndVehicleDropListPromise = getVehicleModelAndVehicleDropList().then(
    res => {
      if (res.data.Code === "10000") {
        store.dispatch(
          "dropDown/saveVehicleModelAndVehicleDropdownList",
          res.data.Data
        );
      }
    }
  );
  //获取OBD取反下拉列表
  let getOBDDropListPromise = getOBDDropList().then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveOBDList", res.data.Data);
    }
  });
  //获取模拟器预约状态下拉列表
  let getEmulatorAppointmentStatusDropListPromise = getEmulatorAppointmentStatusDropList().then(
    res => {
      if (res.data.Code === "10000") {
        store.dispatch(
          "dropDown/saveEmulatorAppointmentStatusList",
          res.data.Data
        );
      }
    }
  );
  //arr.push(getSchoolTeamPromise);
  //arr.push(getLoginNamesPromise);
  //arr.push(getRolesPromise);
  //arr.push(getGroupPromise);
  arr.push(getVehicleTypePromise);
  //arr.push(getPersonTypePromise);
  //arr.push(getDrivingTypePromise);
  //arr.push(getSubitemTypeTwoPromise);
  //arr.push(getGroupTreePromise);
  //arr.push(getVehicleModelSettingPromise);
  // arr.push(GetResourceTypePromise);
  // arr.push(GetResourceTypeKeyPrefixPromise);
  // arr.push(GetFileTypePromise);
  arr.push(getVehicleModelSettingDropListPromise);
  //arr.push(getVehicleModelAndVehicleDropListPromise);
  // arr.push(getOBDDropListPromise);
  arr.push(getEmulatorAppointmentStatusDropListPromise);
  //二级页面或不常用菜单无需等待
  await Promise.all(arr);
}

// 模块：得到可配置的下拉列表项，数据均来自于数据字典。
//得到角色下拉列表
export function getRoles(refreshCache = false) {
  return axios({
    url: "UserRole/GetRoleDropDownList",
    method: "post",
    data: {
      refreshCache: refreshCache
    }
  });
}

//得到登录名下拉列表
export function getLoginNames(refreshCache = false) {
  return axios({
    url: "User/GetLoginNameList",
    method: "post",
    data: {
      refreshCache: refreshCache
    }
  });
}

/**
 * 得到驾校列表(未删除的)
 * @param refreshCache 是否刷新服务端缓存
 */
export function getStation(refreshCache = false) {
  return axios({
    url: "/DriverSchoolInfo/GetDriverSchoolInfoDropdownList",
    method: "post",
    data: {
      refreshCache: refreshCache,
      IsDel: 0
    }
  });
}

/**
 * 得到驾校列表(全部的)
 * @param refreshCache 是否刷新服务端缓存
 */
export function getSchoolAll(refreshCache = false, isDel = 0) {
  return axios({
    url: "/DriverSchoolInfo/GetDriverSchoolInfoDropdownList",
    method: "post",
    data: {
      refreshCache: refreshCache,
      IsDel: isDel
    }
  });
}

/**
 * 得到驾校中队列表
 * @param {*} driverSchoolCode
 * @returns
 */
export function getSchoolTeam(driverSchoolCode, refreshCache = false) {
  return axios({
    url: "/DropDownList/GetTeamList",
    method: "post",
    data: {
      DriverSchoolCode: driverSchoolCode,
      refreshCache: refreshCache
    }
  });
}

/**
 * 得到集团列表
 * @param refreshCache 是否刷新服务端缓存
 */
export function getGroup(refreshCache = false) {
  return axios({
    url: "/Group/GetGroupInfoDropdownList",
    method: "post",
    data: {
      refreshCache: refreshCache
    }
  });
}

//得到车辆类别
export function getVehicleType(driverSchoolCode, refreshCache = false) {
  return axios({
    url: "/DropDownList/GetVehicleTypeList",
    method: "post",
    data: {
      refreshCache: refreshCache,
      DriverSchoolCode: driverSchoolCode
    }
  });
}

//得到号牌种类子列表
export function getLicenseType(refreshCache = false) {
  return axios({
    url: "/DictCode/GetLicenseTypeDict",
    method: "post",
    data: {}
  });
}

//得到收费类型列表
export function getChargeType(refreshCache = false) {
  return axios({
    url: "/DictCode/GetChargeTypeDict",
    method: "post",
    data: {}
  });
}

//得到人员类型列表
export function getPersonType(refreshCache = false) {
  return axios({
    url: "/DictCode/GetPersonTypeDict",
    method: "post",
    data: {
      refreshCache: refreshCache
    }
  });
}

//得到设备类型列表
export function getDeviceType(refreshCache = false) {
  return axios({
    url: "/DictCode/GetDeviceTypeDict",
    method: "post",
    data: {}
  });
}
//得到驾驶证类别列表
export function getDrivingType(refreshCache = false, OwnedStationCode) {
  return axios({
    url: "/DictCode/GetDrivingTypeDict",
    method: "post",
    data: {}
  });
}

//模拟器学时对接平台类型
export function getETimingPlatformType() {
  return axios({
    url: "/DictCode/GetETimingPlatformTypeList",
    method: "post",
    data: {}
  });
}

//获取资源类型字典
export function GetResourceType(refreshCache = false) {
  return axios({
    url: "/DictCode/GetResourceTypeDict",
    method: "post",
    data: {}
  });
}
//获取资源类型KeyPrefix列表
export function GetResourceTypeKeyPrefix(resourceType) {
  return axios({
    url: "/ResourceTypeInfo/GetKeyPrefixList",
    method: "post",
    data: {
      ResourceType: resourceType
    }
  });
}
//获取文件类型字典
export function GetFileType(refreshCache = false) {
  return axios({
    url: "/DictCode/GetFileTypeDict",
    method: "post",
    data: {}
  });
}
//获取车辆品牌字典
export function getVehicleModelSetting(vehicleType) {
  return axios({
    url: "/DropDownList/GetVehicleModelSettingDict",
    method: "post",
    data: {
      VehicleType: vehicleType
    }
  });
}
//获取车辆品牌字典
export function getVehicleModelSettingDropList() {
  return axios({
    url: "/DropDownList/GetVehicleModelSettingDropdownList",
    method: "post",
    data: {}
  });
}
//获取车辆品牌与车牌号对应字典
export function getVehicleModelAndVehicleDropList() {
  return axios({
    url: "/DropDownList/GetVehicleModelAndVehicleDropdownList",
    method: "post",
    data: {}
  });
}

export function getOBDDropList() {
  return axios({
    url: "/DropDownList/GetOBDReversedDropdownList",
    method: "post",
    data: {}
  });
}
//得到车辆类别列表
export function getTrainVehicleType(refreshCache = false) {
  return axios({
    url: "/DictCode/GetTrainVehicleTypeDict",
    method: "post",
    data: {}
  });
}
//获取车辆列表
export function getVehicleList(driverSchoolCode, vehicleType) {
  return axios({
    url: "/VehicleInfo/GetVehicleBySchoolAndType",
    method: "post",
    data: {
      DriverSchoolCode: driverSchoolCode,
      VehicleType: vehicleType
    }
  });
}
//得到教练分组列表
export function getCoachTeamCode(driverSchoolCode) {
  return axios({
    url: "/CoachInfo/GetCoachTeamCode",
    method: "post",
    data: {
      DriverSchoolCode: driverSchoolCode
    }
  });
}
//得到科目二子项类型
export function getSubitemTypeTwo(vehicleType) {
  return axios({
    url: "/DictCode/GetSubitemTypeTwo",
    method: "post",
    data: {
      VehicleType: vehicleType
    }
  });
}

//得到数据字典类型列表
export function getAllDictTypeList(refreshCache = false) {
  return axios({
    url: "/DictCode/GetAllDictType",
    method: "post",
    data: {}
  });
}

/**
 * 得到集团树列表
 * @param refreshCache 是否刷新服务端缓存
 */
export function getGroupTree(refreshCache = false) {
  return axios({
    url: "/Group/GetGroupInfoTreeDropdownList",
    method: "post",
    data: {
      refreshCache: refreshCache
    }
  });
}

/**
 * 获取模拟器预约状态下拉列表
 * @param {*} refreshCache
 * @returns
 */
export function getEmulatorAppointmentStatusDropList(refreshCache = false) {
  return axios({
    url: "/DropDownList/GetEmulatorAppointmentStatusDropdownList",
    method: "post",
    data: {
      refreshCache: refreshCache
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/DropDownList.js